import React  from 'react';

import shixisheng1 from '../assets/img/shixisheng1.png';
import shixisheng2 from '../assets/img/shixisheng2.png';

const Enclosure32 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div>
            <img src={shixisheng1} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={shixisheng2} alt="" style={{
                width  : '80%',
                display: 'block',
                margin : '0 auto'
            }}/>
            
            <br/><br/>
        </div>
    </div>



export default Enclosure32;